// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  agentId: __t.u64().primaryKey().name("agent_id"),
  workspaceId: __t.u64().name("workspace_id"),
  seatKey: __t.string().name("seat_key"),
  displayName: __t.string().name("display_name"),
  roleTitle: __t.string().name("role_title"),
  prompt: __t.string(),
  scoreState: __t.string().name("score_state"),
  createdAt: __t.i64().name("created_at"),
  avatarUrl: __t.string().name("avatar_url"),
  kind: __t.string(),
  triggerJson: __t.string().name("trigger_json"),
  fireLimitPerTurn: __t.u32().name("fire_limit_per_turn"),
  muted: __t.bool(),
  modelBacking: __t.string().name("model_backing"),
});
